import { BasedModel, getModifiers } from '@src/helpers/getModifiers';
import { FC, FormEventHandler, useState } from 'react';
import IconWithTooltip, { IconWithTooltipModel } from '../icon-with-tooltip/IconWithTooltip';

export interface TextboxModel extends BasedModel {
  type: 'textbox';
  hasError?: boolean;
  placeholder?: string;
  name?: string;
  label?: string;
  message?: string;
  handleInput?: FormEventHandler<HTMLInputElement>;
  value?: string;
  defaultValue: string;
  extraClassname?: string;
  requiredMessage?: string;
  passwordInputSetting?: {
    showLabel: string;
    hideLabel: string;
  };
  isDisabled?: boolean;
  autocompleted?: string;
  tooltip?: IconWithTooltipModel;
  required?: boolean;
}

export const Textbox: FC<TextboxModel> = (props) => {
  const styleModifiers = getModifiers(props, 'fm-o-textbox');
  const [show, setShow] = useState(!props.passwordInputSetting ? true : false);
  const handleToggleClick = () => setShow(!show);
  return (
    <div
      className={`${styleModifiers} ${props.tooltip ? 'fm-o-textbox--tooltip' : ''} ${props.hasError ? 'fm-o-textbox--error' : ''} ${
        props.isDisabled ? 'fm-o-textbox--disabled' : ''
      } ${props.extraClassname ?? ''}`}
    >
      <div className="fm-o-textbox__main">
        <input
          name={props.name}
          className="fm-o-textbox__input tfm"
          placeholder={props.placeholder}
          onInput={props.handleInput}
          value={props.value}
          disabled={props.isDisabled}
          autoComplete={props.autocompleted}
          type={props.passwordInputSetting && !show ? 'password' : undefined}
        ></input>

        {props.label && <label className="fm-o-textbox__label">{props.label}</label>}

        {props.passwordInputSetting && (
          <label className="fm-o-textbox__toggle" onClick={handleToggleClick}>
            {show ? props.passwordInputSetting.hideLabel : props.passwordInputSetting.showLabel}
          </label>
        )}

        {props.tooltip && !props.hasError && (
          <div className="fm-o-textbox__tooltip">
            <IconWithTooltip {...props.tooltip} />
          </div>
        )}
      </div>

      <span className="fm-o-textbox__message">{props.message ?? ''}</span>
    </div>
  );
};
